import {
  FETCH_CRITERIA_BEGIN,
  FETCH_CRITERIA_SUCCESS,
  STATES,
  FETCH_CRITERIA_FAILURE,
  POST_PREFERENCE_BEGIN,
  POST_PREFERENCE_SUCCESS,
  POST_PREFERENCE_FAILURE,
  FETCH_PREFERENCE_BEGIN,
  FETCH_PREFERENCE_SUCCESS,
  FETCH_PREFERENCE_FAILURE,
  CRITERIA_FOR_DATATABLE,
  JURISDICTION,
  FETCH_STATELIST_BEGIN,
  FETCH_JURISDICTION_BEGIN,
  FETCH_PLANTYPES_BEGIN,
  FETCH_CODEBOOK_BEGIN,
  PLAN_TYPES,
  CODEBOOK,
  RESET_JURISDICTION,
  RESET_PLANTYPE,
  RESET_CODEBOOK,
} from "@safecv/actions/types";

const initialState = {
  disciplines: [],
  isChecked: true,
  states: [],
  jurisdictions: [],
  spinnerLoading: false,
  status: [],
  sourceOfPlan: [],
  planTypes: [],
  codebooks: [],
  preference: null,
  planTypeFilterData: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_CRITERIA_BEGIN:
      return {
        ...state,
        spinnerLoading: true,
      };
    case FETCH_CRITERIA_SUCCESS:
      return {
        ...state,
        disciplines: action.payload.disciplines,
        states: action.payload.states,
        jurisdiction: action.payload.jurisdiction,
        isChecked: action.payload.check,
        spinnerLoading: false,
      };
    case FETCH_CRITERIA_FAILURE:
      return {
        ...state,
        spinnerLoading: false,
      };
    case POST_PREFERENCE_BEGIN:
      return {
        ...state,
        spinnerLoading: true,
      };
    case POST_PREFERENCE_SUCCESS:
      return {
        ...state,
        disciplines: action.payload.disciplines,
        states: action.payload.states,
        jurisdiction: action.payload.jurisdiction,
        isChecked: action.payload.check,
        spinnerLoading: false,
      };
    case POST_PREFERENCE_FAILURE:
      return {
        ...state,
        spinnerLoading: false,
      };
    case FETCH_PREFERENCE_BEGIN:
      return {
        ...state,
        spinnerLoading: true,
      };
    case FETCH_PREFERENCE_SUCCESS:
      return {
        ...state,
        preference: action.payload.preference,
      };
    case FETCH_PREFERENCE_FAILURE:
      return {
        ...state,
        spinnerLoading: false,
      };

    case CRITERIA_FOR_DATATABLE: {
      return {
        ...state,
        status: action.payload.status,
        sourceOfPlan: action.payload.sourceOfPlan,
        planTypeFilterData: action.payload.planTypeFilterData,
      };
    }
    case FETCH_STATELIST_BEGIN:
      return {
        ...state,
        spinnerLoading: true,
      };

    case FETCH_JURISDICTION_BEGIN: {
      return {
        ...state,
        spinnerLoading: true,
      };
    }

    case FETCH_PLANTYPES_BEGIN: {
      return {
        ...state,
        spinnerLoading: true,
      };
    }
    case FETCH_CODEBOOK_BEGIN: {
      return {
        ...state,
        spinnerLoading: true,
      };
    }

    case PLAN_TYPES: {
      return {
        ...state,
        planTypes: action.payload.planTypes,
        spinnerLoading: false,
      };
    }

    case CODEBOOK: {
      return {
        ...state,
        codebooks: action.payload.codebooks,
        spinnerLoading: false,
      };
    }

    case STATES: {
      return {
        ...state,
        states: action.payload.states,
        spinnerLoading: false,
      };
    }

    case JURISDICTION: {
      return {
        ...state,
        jurisdictions: action.payload.jurisdictions,
        spinnerLoading: false,
      };
    }

    case RESET_JURISDICTION: {
      return {
        ...state,
        jurisdictions: [],
      };
    }

    case RESET_PLANTYPE: {
      return {
        ...state,
        planTypes: [],
      };
    }

    case RESET_CODEBOOK: {
      return {
        ...state,
        codebooks: [],
      };
    }

    default:
      return state;
  }
}
